/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { Checkbox, Input, Button, Collapse } from 'antd'
import JobTriggers from './JobTriggers'
import styled from 'styled-components'
import R from 'ramda'
import moment from 'moment'
import { fromNullable } from 'data.maybe'

const Label = styled.div`
  align-items: center;
`

const Row = styled.div`
  display: flex;
  align-items: center;
`
const rightMargin = {
  marginRight: '5px',
}

const Fill = styled.div`
  flex: 1 1 2px;
`
const BottomContainer = styled.div`
  height: ${({ edited }) => (edited ? '290px' : '270px')};
  margin-left: 30px;
  display: flex;
  flex-direction: column;
`

const LogControl = styled.div`
  flex: 1 0 250px;
`
const JobName = styled.span`
  text-decoration: ${({ active }) => (active ? 'none' : 'line-through')};
  color: ${({ active }) => (active ? 'black' : 'grey')};
`
const LogTitle = styled.div`
  font-size: 1.1em;
  margin-top: 15px;
  color: white;
  padding: 5px;
  background-color: steelblue;
  font-weight: bold;
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-left: solid white 1px;
  height: 40px;
  display: flex;
  align-items: center;
  border-top-right-radius: 3px;
`
const LogContainer = styled.div`
  overflow: auto;
  border-bottom: solid #ddd 1px;
  max-width: 100%;
  height: 100%;
  border-left: solid #ddd 1px;
  border-right: solid #ddd 1px;
  padding: 10px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
`
const TriggerAndLog = styled.div`
  display: flex;
  align-items: stretch;
  height: 200px;
`

const LogRow = styled.div`
  display: flex;
  margin-bottom: 5px;
  align-items: center;
  border-bottom: solid #eee 1px;
`
const StackTrace = styled.a`
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 3em;
  max-width: 450px;
`
const TimeStamp = styled.span`
  flex: 0 0 250px;
  text-align: center;
`
const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const NoData = styled.div`
  border-bottom: solid #ddd 1px;
  height: 100%;
  border-left: solid #ddd 1px;
  border-right: solid #ddd 1px;
  padding: 10px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2em;
  color: #888;
  font-weight: bold;
`

class JobItem extends React.PureComponent {
  constructor(props) {
    super(props)
    const { app, path, active, triggers } = this.props
    this.state = {
      app,
      path,
      active,
      triggers,
      expanded: false,
      edited: false,
      triggering: false,
    }
    this.toggleExpanded = this.toggleExpanded.bind(this)
    this.toggleActive = this.toggleActive.bind(this)
    this.editData = this.editData.bind(this)
    this.cancelEdit = this.cancelEdit.bind(this)
    this.saveData = this.saveData.bind(this)
    this.triggerJob = this.triggerJob.bind(this)
  }

  saveData() {
    const { path, active, triggers } = this.state
    const { jobName, app, save } = this.props
    save &&
      save({
        jobName,
        app,
        triggers,
        path,
        active,
      })
  }

  done = () => this.setState({ triggering: false })

  triggerJob() {
    const { path, active } = this.state
    const { jobName, app, triggers, trigger } = this.props
    if (trigger) {
      this.setState({ triggering: true }, () =>
        trigger({
          jobName,
          app,
          triggers,
          path,
          active,
        }).fork(this.done, this.done)
      )
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.triggers !== prevProps.triggers ||
      this.props.path !== prevProps.path ||
      this.props.active !== prevProps.active
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ edited: false, triggers: this.props.triggers })
    }
  }

  toggleExpanded() {
    this.setState(({ expanded }) => ({
      expanded: !expanded,
    }))
  }

  toggleActive() {
    this.setState(({ active }) => ({ active: !active, edited: true }))
  }

  editData(e) {
    this.setState({
      [e.target.name]: e.target.value,
      edited: true,
    })
  }

  cancelEdit() {
    const { app, path, active, triggers } = this.props
    this.setState({
      app,
      path,
      active,
      triggers,
      expanded: true,
      edited: false,
    })
  }

  updateTriggers = triggers => {
    this.setState({
      triggers,
      edited: true,
    })
  }

  render() {
    const { app, jobName, recentRecords, availableTriggers } = this.props
    // eslint-disable-next-line no-unused-vars
    const { path, active, triggers, expanded, edited } = this.state
    const lastRecord = recentRecords[0] || {}
    const { startStamp, endStamp, status } = lastRecord
    // antd not support indirect inner Collapse
    return (
      <Collapse>
        <Collapse.Panel
          active
          // onClick={this.toggleExpanded}
          key={app + jobName}
          header={
            <Row>
              {/* <Icon name={expanded ? 'caret down' : 'caret right'} /> */}
              <JobName active={active} style={rightMargin}>
                {app} - {jobName}
              </JobName>
              <Label
                style={{
                  ...rightMargin,
                  color: active ? 'green' : 'grey',
                  borderBottom: active ? '1px solid green' : '1px solid grey',
                }}
                basic
              >
                {active ? 'Enabled' : 'Disabled'}
              </Label>
              <Fill />
              {R.isEmpty(lastRecord) ? (
                <Label basic color="grey">
                  No Run Recorded
                </Label>
              ) : (
                [
                  <span key="1" style={rightMargin}>
                    Last run
                  </span>,
                  <Label
                    key="2"
                    style={{
                      ...rightMargin,
                      color:
                        status == null
                          ? 'orange'
                          : status === 'SUCCESS'
                          ? 'green'
                          : 'red',
                      borderBottom:
                        status == null
                          ? '1px solid orange'
                          : status === 'SUCCESS'
                          ? '1px solid green'
                          : '1px solid red',
                    }}
                    basic
                  >
                    {status == null ? 'Running' : status}
                  </Label>,
                  <span
                    key="3"
                    title={fromNullable(endStamp)
                      .chain(end =>
                        fromNullable(startStamp).map(start => ({ start, end }))
                      )
                      .map(({ start, end }) => moment(end).diff(moment(start)))
                      .map(
                        diff => 'Task took ' + moment.duration(diff).humanize()
                      )
                      .getOrElse(null)}
                  >
                    {fromNullable(endStamp)
                      .orElse(() => fromNullable(startStamp))
                      .map(_ =>
                        moment(endStamp).format(
                          'dddd, MMMM Do YYYY, HH:mm:ss.SSSZ '
                        )
                      )
                      .getOrElse(d => ' on ' + d)}
                  </span>,
                ]
              )}
            </Row>
          }
        >
          <BottomContainer edited={edited}>
            <Row>
              <Checkbox
                label="Enabled"
                checked={active}
                onClick={this.toggleActive}
                style={rightMargin}
              >
                Enabled
              </Checkbox>
              <Input
                style={{ flex: '1 0 100px' }}
                label="Service Path"
                placeholder="url to runner service"
                onChange={this.editData}
                value={path}
                name="path"
              />
              <Button
                disabled={!active}
                onClick={this.triggerJob}
                style={{ marginLeft: '5px' }}
                type="danger"
                loading={this.state.triggering}
              >
                Trigger Job
              </Button>
              {edited && (
                <Buttons>
                  <Button
                    type="primary"
                    onClick={this.saveData}
                    style={{ marginLeft: '10px' }}
                  >
                    Save
                  </Button>
                  <Button
                    type="dashed"
                    onClick={this.cancelEdit}
                    style={{ marginLeft: '10px' }}
                  >
                    Cancel
                  </Button>
                </Buttons>
              )}
            </Row>
            <TriggerAndLog>
              <JobTriggers
                style={{ flex: '0 0 250px' }}
                jobTriggers={triggers}
                availableTriggers={availableTriggers}
                updateTriggers={this.updateTriggers}
              />
              <LogControl>
                <LogTitle>Run History</LogTitle>
                {recentRecords.length === 0 && (
                  <NoData>No Run Recorded </NoData>
                )}
                {recentRecords.length > 0 && (
                  <LogContainer>
                    {recentRecords.map(
                      (
                        { status, startStamp, endStamp, throwableStackTrace },
                        i
                      ) => (
                        <LogRow key={i}>
                          <Label
                            key="2"
                            style={{
                              ...rightMargin,
                              flex: '0 0 100px',
                              textAlign: 'center',
                            }}
                            color={
                              status == null
                                ? 'orange'
                                : status === 'SUCCESS'
                                ? 'green'
                                : 'red'
                            }
                            basic
                          >
                            {status == null ? 'RUNNING' : status}
                          </Label>
                          <TimeStamp
                            title={fromNullable(endStamp)
                              .chain(end =>
                                fromNullable(startStamp).map(start => ({
                                  start,
                                  end,
                                }))
                              )
                              .map(({ start, end }) =>
                                moment(end).diff(moment(start))
                              )
                              .map(
                                diff =>
                                  'Task took ' +
                                  moment.duration(diff).humanize()
                              )
                              .getOrElse(null)}
                          >
                            {fromNullable(endStamp)
                              .orElse(() => fromNullable(startStamp))
                              .map(_ =>
                                moment(endStamp).format(
                                  'dddd, MMMM Do YYYY, HH:mm:ss.SSSZ '
                                )
                              )
                              .getOrElse(d => ' on ' + d)}
                          </TimeStamp>
                          <StackTrace
                            onClick={e => {
                              e.preventDefault()
                              this.props.setError({
                                errorMsg: `Job ${app} - ${jobName} ${
                                  endStamp
                                    ? 'encoutnered error on ' +
                                      moment(endStamp).format(
                                        'dddd, MMMM Do YYYY, HH:mm:ss.SSSZ '
                                      )
                                    : ' encountered error'
                                }`,
                                stackTrace: throwableStackTrace,
                              })
                            }}
                            href="#"
                          >
                            {throwableStackTrace}
                          </StackTrace>
                        </LogRow>
                      )
                    )}
                  </LogContainer>
                )}
              </LogControl>
            </TriggerAndLog>
          </BottomContainer>
        </Collapse.Panel>
      </Collapse>
    )
  }
}

export default JobItem
